export const ORDER_TYPES = {
  user: 'user',
  buy: 'buy',
  sell: 'sell'
}



// WEBPACK FOOTER //
// ./src/js/const/order-types.js